import React, { useEffect, useState, useMemo } from 'react';
import PropTypes from 'prop-types';
import { AutoCompleteField } from '../../../components/widgets';
import fieldVisibilityRules from '../../../selectors/reportsConfig/fieldVisibilityRules';
import css from '../DataDestinationShelf.css';

export default function CreativeIQCustomSchemaFields({ readonly = false, selected = [], getOptions, onChange }) {
    const aiDimensionsOptions = getOptions('creativesAIDimensions', fieldVisibilityRules.creatives);
    const aiCustomDimensionsOptions = getOptions('creativesAICustomDimensions', fieldVisibilityRules.creatives);

    const allAiOptions = useMemo(() => [...aiDimensionsOptions, ...aiCustomDimensionsOptions], [
        aiDimensionsOptions,
        aiCustomDimensionsOptions,
    ]);
    const [selectedAiFields, setSelectedAiFields] = useState([]);

    useEffect(() => {
        if (readonly && selected) {
            // Filter selected fields to find AI dimensions and custom dimensions
            const filteredAiFields = allAiOptions.filter(field => selected.includes(field.value));
            setSelectedAiFields(filteredAiFields);
        }
    }, [readonly, selected, allAiOptions]);

    useEffect(() => {
        if (readonly) {
            return;
        }

        // Create mapping from selected AI fields
        const aiFieldsMapping = selectedAiFields.reduce((mapping, field) => {
            mapping[field.value] = field.label;
            return mapping;
        }, {});

        onChange(aiFieldsMapping);
    }, [readonly, selectedAiFields, onChange]);

    const autocompleteProps = {
        disabled: readonly,
        clearable: true,
        searchable: true,
        containerClass: css.field,
    };

    return (
        <AutoCompleteField
            value={selectedAiFields}
            label="STATIC.AI_TAGS"
            options={allAiOptions}
            onChange={setSelectedAiFields}
            onInputChange={setSelectedAiFields}
            {...autocompleteProps}
        />
    );
}

CreativeIQCustomSchemaFields.propTypes = {
    readonly: PropTypes.bool,
    selected: PropTypes.arrayOf(PropTypes.string),
    onChange: PropTypes.func.isRequired,
    getOptions: PropTypes.func.isRequired,
};
